<template>
    <div>
        <div style="display: flex;justify-content: space-between;width: 70%">
            <div></div>
            <div>
                <el-button icon="el-icon-refresh-right" type="success" @click="initStorageStats">刷新</el-button>
            </div>
        </div>

        <div class="storage-mng-main">
            <el-table
                    :data="storageStats"
                    v-loading="loading"
                    border
                    @selection-change="handleSelectionChange"
                    size="small"
                    stripe
                    style="width: 70%">
                <el-table-column
                        type="selection"
                        align="center"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="id"
                        label="ID"
                        align="center"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="desc"
                        label="状态描述"
                        align="center"
                        width="200">
                    <template slot-scope="scope">
                    <el-tag color="#FFFFFF">{{scope.row.desc}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        prop="createTime"
                        label="创建时间">
                </el-table-column>
                <el-table-column
                        align="center"
                        prop="updateTime"
                        label="更新时间">
                </el-table-column>

            </el-table>

        </div>

    </div>
</template>

<script>
    export default {
        name: "StorageMng",
        data() {
            return {
                loading: false,
                storageStats: []
            }
        },
        mounted() {
            this.initStorageStats();
        },
        methods: {
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            initStorageStats() {
                this.loading = true;
                this.getRequest("/dev/basic/storageStats").then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.storageStats = resp.data;
                    }
                })
            }
        }
    }
</script>

<style>
    .storage-mng-main {
        margin-top: 10px;
    }
</style>